import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./sobre_mim_draalinesouza.module.scss";
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const Sobre_mim_draalinesouza: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.sobre_mim_draalinesouza}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/draalinesouza" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Sobre mim</h1>
            </div>

            {/* CONTEÚDO */}
            <div className={styles.content}>
                <div className={styles.imageContainer}>
                    <img src={require("./src/img_sobremim.png")} alt="Dra. Aline Souza" />
                </div>
                <h2>Dra. Aline Souza</h2>
                <p>
                    Dentista formada pela Unifeb, e pós graduada em Harmonização
                    Orofacial pela Facsete e com diversas especializações em HOF.
                </p>
                <p>
                    Sou apaixonada pela área da estética e da harmonização orofacial.
                    Minha missão é transformar não apenas sorrisos, mas também autoestima
                    e confiança, sempre com naturalidade e cuidado.
                </p>
                <p>
                    Na minha jornada profissional, busco estar em constante evolução,
                    participando de cursos, congressos e atualizações, porque acredito que
                    cada paciente merece o melhor da ciência e da arte da estética.
                </p>
                <p>
                    Além da vida profissional, sou alguém que valoriza as pequenas
                    alegrias do dia a dia: um bom café, boas conversas e momentos leves ao
                    lado de quem eu amo.
                </p>
                <p>
                    Aqui no meu Instagram, você vai encontrar um pouco do meu trabalho,
                    meu olhar sobre beleza e bem-estar, e também pedacinhos da minha vida.
                    Porque acredito que ser profissional é também ser humana, e é isso que
                    me conecta com cada um de vocês.
                </p>
            </div>

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>


                    <a href="https://wa.me/5517981553468?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio." target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><WhatsappIcon height="30" color="#ffffff" /></div>
                            <span>WhatsApp</span>
                        </div>
                    </a>
                    <a href="https://maps.app.goo.gl/17YEuYRRp2u8Y8Ty6" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><MapsIcon height="30" color="#ffffff" /></div>
                            <span>Localização</span>
                        </div>
                    </a>
                    <a href="https://www.instagram.com/draalinesouza?igsh=MTN4M2lyeGFtZDhscA==" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><InstagramIcon height="26" color="#ffffff" /></div>
                            <span>Instagram</span>
                        </div>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Sobre_mim_draalinesouza;
